<template>
  <section>
    <h2>{{ collection.title }}</h2>
    <ul class="collection">
      <li
        v-for="(route, index) in collection.routes.filter(r => r.is === 'Products')"
        :key="index"
      >
        <router-link :to="[routePath, route.path] | joinPath">
          {{ route.id }}
        </router-link>
      </li>
    </ul>
  </section>
</template>
<script>

export default {
  name: 'Collection',
  components: {
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
    routePath() {
      return this.$route.path;
    },
    collection() {
      const items = this.$store.state.config.routes.find(item => item.id === this.routeName);
      return items;
    },
  },
  watch: {

  },
  mounted() {

  },
};
</script>

<style lang="stylus" scoped>
section {
  display: flex;
  height: $block-height;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h2 {
    font-size: $fs-xxl;
  }
  ul {
    display: block;
  }
  li {
    margin: 50px;
  }
  a {
    font-size: $fs-l;
  }
}

</style>
